import { render } from "./Note.vue?vue&type=template&id=60c2094a&ts=true"
import script from "./Note.vue?vue&type=script&lang=ts"
export * from "./Note.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__